import cn from 'classnames'
import CheckboxIcon from 'public/images/icons/checkbox-checked.svg'

import Checkbox from 'components/checkbox'

import css from './item-checkbox.module.scss'

type SelectItemProps = {
  isSelected: boolean
  id: string
  label: string
  name: string
  onChange: (isChecked: boolean) => void
  children?: React.ReactNode
}

const ItemCheckbox = ({ isSelected, id, name, label, onChange, children }: SelectItemProps) => {
  return (
    <li className={css.itemCheckbox}>
      <label className={cn([css.itemLabel, isSelected && css.labelSelected])} htmlFor={id}>
        <Checkbox
          id={id}
          name={name}
          className={css.checkboxInput}
          isChecked={isSelected}
          onChange={onChange}
          CheckedIcon={<CheckboxIcon />}
        />
        {children ? children : <p className={cn([css.label])}>{label}</p>}
      </label>
    </li>
  )
}

export default ItemCheckbox
